import styled from "styled-components";
import { shimmerFill } from "../../../design-system/tokens/shimmer";
import { spacing } from "../../../design-system/tokens/spacing";
import { borderRadius } from "../../../design-system/tokens/borders";

/** Generic shimmer bar — height/width set per use-site via style prop. */
export const SkeletonBar = styled.div<{ $w?: string; $h?: number }>`
  height: ${({ $h }) => ($h ?? 16)}px;
  width: ${({ $w }) => $w ?? "100%"};
  border-radius: ${borderRadius.xl};
  ${shimmerFill}
  flex-shrink: 0;
`;

/** Pill-shaped chip skeleton (for Audience section). */
export const SkeletonPill = styled(SkeletonBar)`
  border-radius: 9999px;
`;

/** Card-box skeleton (for Format / Layout cards). */
export const SkeletonCardBox = styled(SkeletonBar)`
  border-radius: ${borderRadius.xl};
  flex: 1 1 0;
`;

/** Row wrapper for bars. */
export const SkeletonRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[2]};
  width: 100%;
`;

/** Row wrapper for horizontal chips / cards. */
export const SkeletonHRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[2]};
  width: 100%;
`;
